// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import { NewPlant, type Plant, type PlantWireFormat } from '../Plant/Plant';
import {
  NewQuoteConfigProduct,
  type QuoteConfigProduct,
  type QuoteConfigProductWireFormat,
} from '../QuoteConfigProduct/QuoteConfigProduct';

export class QuoteConfig {
  readonly id: string;
  readonly name: string;
  readonly terms: string;
  readonly plants: Plant[];
  readonly isArchived: boolean;
  readonly products: QuoteConfigProduct[];

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.terms = data.terms === undefined ? '' : data.terms;
    this.plants = (data.plants ?? []).map((plants: any) => NewPlant(plants));
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
    this.products = (data.products ?? []).map((products: any) => NewQuoteConfigProduct(products));
  }

  static zero(): QuoteConfig {
    const zeroValues: ExcludeMethodsDeep<QuoteConfig> = {
      id: NIL_UUID,
      name: '',
      terms: '',
      plants: [],
      isArchived: false,
      products: [],
    };
    return new QuoteConfig(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuoteConfigWireFormat = {
  id: string;
  name: string;
  terms: string;
  plants: PlantWireFormat[];
  isArchived: boolean;
  products: QuoteConfigProductWireFormat[];
};

type NewQuoteConfigProps = PartialDeep<QuoteConfig, { recurseIntoArrays: true }>;
export const NewQuoteConfig: (props: NewQuoteConfigProps) => QuoteConfig = (props) =>
  new QuoteConfig(props);

type NewQuoteConfigFromWireFormatProps = PartialDeep<
  QuoteConfigWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuoteConfigFromWireFormat: (
  props: NewQuoteConfigFromWireFormatProps,
) => QuoteConfig = (props) => new QuoteConfig(props);
